// https://github.com/Dan503/time-input-polyfill/blob/08463f7823efd30a62f4d4755dd0bd2dd2b5ef04/core/static-values/all_number_keys.js
export default [
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105,
]
